import { render, staticRenderFns } from "./AIChatResolvedProductCards.vue?vue&type=template&id=8a639cb6&scoped=true"
import script from "./AIChatResolvedProductCards.vue?vue&type=script&lang=js"
export * from "./AIChatResolvedProductCards.vue?vue&type=script&lang=js"
import style0 from "./AIChatResolvedProductCards.vue?vue&type=style&index=0&id=8a639cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a639cb6",
  null
  
)

export default component.exports